module.exports = __webpack_public_path__ + "static/media/europe.bfdc5c49.svg";